/* Nanocoating.nl — Slim blogsysteem (fase 1). Geen externe libraries. */
(function () {
  'use strict';
  if (window.NCEBlog) return;

  var routeRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SKIP = '.nce-blog, nav, header, footer, aside, form, [data-nce-skip], [class*="comment"], [id*="comment"]';

  /* ---------- hulpfuncties ---------- */
  function norm(s) {
    return ' ' + String(s || '').toLowerCase()
      .replace(/[-_/,.:;!?()"'’‘&+–—]/g, ' ')
      .replace(/\s+/g, ' ').trim() + ' ';
  }
  function needle(w) {
    w = String(w || '').trim().toLowerCase();
    if (!w) return '';
    return w.slice(-1) === '*' ? ' ' + w.slice(0, -1) : ' ' + w + ' ';
  }
  function list(s) { return String(s || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); }
  function slug(t) {
    var s = String(t).normalize ? String(t).normalize('NFD').replace(/[̀-ͯ]/g, '') : String(t);
    s = s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
    return s || 'sectie';
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function textOf(html) {
    try { return new DOMParser().parseFromString(String(html || ''), 'text/html').body.textContent.replace(/\s+/g, ' ').trim(); }
    catch (e) { return ''; }
  }
  function clip(s, n) { return s.length > n ? s.slice(0, n).replace(/\s+\S*$/, '') + '…' : s; }
  function samePath(a, b) {
    try { return new URL(a, location.href).pathname.replace(/\/$/, '') === new URL(b, location.href).pathname.replace(/\/$/, ''); }
    catch (e) { return false; }
  }

  /* ---------- artikeltekst vinden ---------- */
  function headingsIn(node, h3) {
    return Array.prototype.filter.call(node.querySelectorAll(h3 ? 'h2, h3' : 'h2'), function (h) {
      return !h.closest(SKIP) && h.textContent.trim() !== '';
    });
  }
  function findContent(root) {
    var sels = list(root.getAttribute('data-selector')).concat(['article']);
    for (var i = 0; i < sels.length; i++) {
      var found;
      try { found = document.querySelectorAll(sels[i]); } catch (e) { continue; }
      for (var j = 0; j < found.length; j++) {
        if (!root.contains(found[j]) && !found[j].closest('.nce-blog') && headingsIn(found[j], false).length) return found[j];
      }
    }
    return null;
  }

  /* ---------- inhoudsopgave ---------- */
  function buildToc(root, content) {
    if (root.getAttribute('data-toc') !== 'true') return;
    var tpl = root.querySelector('template[data-nce-tpl="toc"]');
    if (!tpl) return;
    if (content.querySelector('.nce-blog-toc, [class*="table-of-contents"], [id*="inhoudsopgave"], [class*="inhoudsopgave"], [id="toc"], .toc')) return;
    var h3 = root.getAttribute('data-toc-h3') === 'true';
    var heads = headingsIn(content, h3);
    var h2count = heads.filter(function (h) { return h.tagName === 'H2'; }).length;
    if (h2count < (parseInt(root.getAttribute('data-toc-min'), 10) || 3)) return;

    var nav = tpl.content.firstElementChild.cloneNode(true);
    var ol = nav.querySelector('.nce-blog-toc__list'), sub = null, used = {};
    heads.forEach(function (h) {
      if (!h.id) {                                  /* bestaande ID's blijven ongemoeid */
        var base = slug(h.textContent), id = base, n = 2;
        while (document.getElementById(id) || used[id]) id = base + '-' + n++;
        h.id = id;
      }
      used[h.id] = true;
      h.style.scrollMarginTop = 'var(--nce-offset, 90px)';
      var li = el('li', 'nce-blog-toc__item'), a = el('a', 'nce-blog-toc__link', h.textContent.replace(/\s+/g, ' ').trim());
      a.href = '#' + encodeURIComponent(h.id);
      li.appendChild(a);
      if (h.tagName === 'H3' && ol.lastElementChild) {
        if (!sub || sub.parentNode !== ol.lastElementChild) { sub = el('ol', 'nce-blog-toc__sub'); ol.lastElementChild.appendChild(sub); }
        sub.appendChild(li);
      } else { ol.appendChild(li); sub = null; }
    });
    nav.style.setProperty('--nce-offset', root.style.getPropertyValue('--nce-offset') || '90px');
    nav.style.setProperty('--nce-accent', root.style.getPropertyValue('--nce-accent') || '#2f7d4f');
    var details = nav.querySelector('details');
    if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) details.removeAttribute('open');

    nav.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a.nce-blog-toc__link');
      if (!a) return;
      var t = document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)));
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', '#' + encodeURIComponent(t.id));
      if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
      t.focus({ preventScroll: true });
      track(root, 'blog_toc_click', {});
    });

    var first = headingsIn(content, false)[0];          /* na de inleiding, vóór de eerste H2 */
    first.parentNode.insertBefore(nav, first);
  }

  /* ---------- blokken op een logische plek in het artikel zetten ----------
     Plek = "vóór H2 nummer i" (i = 1..n-1) of i = n: aan het einde van de artikeltekst.
     Elke plek krijgt bij voorkeur maar één blok; anders schuift het blok door. */
  var RX = {
    steps: /(stappenplan|stap voor stap|stappen|aan de slag|werkwijze|zo pak je|zo ga je|aanbrengen|toepassen|zo doe je|hoe (je|kun|kan|ga|pak|maak|verwijder|reinig|behandel|impregneer|bescherm))/i,
    work: /(hoe werkt|werking|waarom|wat is|wat doet)/i,
    faq: /(veelgestelde vragen|veel gestelde vragen|faq|vragen en antwoorden)/i,
    end: /(conclusie|tot slot|samenvatting|samengevat|over nanocoating)/i
  };
  function findIdx(h2, rx, from) {
    for (var i = from || 1; i < h2.length; i++) if (rx.test(h2[i].textContent)) return i;
    return -1;
  }
  function placeAll(root, content) {
    var h2 = headingsIn(content, false), n = h2.length;
    if (!n) return;
    var accent = root.style.getPropertyValue('--nce-accent') || '#2f7d4f';
    var used = {}, items = [];

    /* 1. productkaart + keuzehulp: net na het midden (uiterlijk vóór de veelgestelde vragen) */
    var panel = root.querySelector('[data-nce-panel]');
    if (panel && root.getAttribute('data-panel-early') === 'true' && n >= 2) {
      var half = Math.max(2, Math.ceil(n / 2) + 1), f = findIdx(h2, RX.faq, 2), w = f > -1 ? Math.min(f, half) : half;
      if (w > n) w = n;
      items.push({ el: panel, want: w, panel: true });
    }
    /* 2. compacte keuzehulp vroeg, na het eerste hoofdstuk */
    var tpl = root.querySelector('template[data-nce-tpl="mid"]');
    if (tpl && root.getAttribute('data-mid') === 'true' && n >= (parseInt(root.getAttribute('data-mid-min'), 10) || 3)) {
      var box = tpl.content.firstElementChild.cloneNode(true);
      items.unshift({ el: box, want: 1, fixed: true });
    }

    items.forEach(function (it) {
      var i = it.want, tries = 0;
      while (used[i] && tries < n) { i = i + 1 > n ? 1 : i + 1; tries++; }  /* volgende vrije plek */
      if (it.panel && used[i] && !used[n]) i = n;
      if (used[i]) { var prev = used[i]; prev.parentNode.insertBefore(it.el, prev.nextSibling); return; }
      used[i] = it.el;
      it.el.style.setProperty('--nce-accent', accent);
      it.el.classList.add('nce-blog-inline');
      if (i >= n) {
        var last = h2[n - 1], end = last.parentNode;
        end.appendChild(it.el);
      } else {
        h2[i].parentNode.insertBefore(it.el, h2[i]);
      }
    });
  }

  /* ---------- Lees ook: Shopify Predictive Search API ---------- */
  function related(root) {
    var box = root.querySelector('[data-nce-related]');
    if (!box || root.getAttribute('data-related') !== 'true' || !window.fetch) return;
    var terms = list(root.getAttribute('data-related-terms')).filter(function (t, i, a) { return a.indexOf(t) === i; }).slice(0, 3);
    var checks = list(root.getAttribute('data-related-words')).map(needle).filter(Boolean);
    var self = root.getAttribute('data-article-url');
    if (!terms.length || !checks.length) return;

    function load() {
      var out = [], seen = {};
      var run = terms.reduce(function (p, term) {
        return p.then(function () {
          if (out.length >= 3) return;
          var url = routeRoot + 'search/suggest.json?q=' + encodeURIComponent(term) +
            '&resources[type]=article&resources[limit]=10&resources[options][fields]=title,tag';
          return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (j) {
              var arts = (j && j.resources && j.resources.results && j.resources.results.articles) || [];
              arts.forEach(function (a) {
                if (out.length >= 3 || !a || !a.url || !a.title) return;
                if (samePath(a.url, self) || seen[a.url]) return;
                var t = norm(a.title);                  /* alleen tonen als de titel bij het onderwerp past */
                if (!checks.some(function (c) { return t.indexOf(c) > -1; })) return;
                seen[a.url] = true; out.push(a);
              });
            }).catch(function () {});
        });
      }, Promise.resolve());
      run.then(function () { render(out); });
    }
    function render(items) {
      if (!items.length) return;
      var ul = box.querySelector('.nce-blog-related__list');
      items.forEach(function (a) {
        var li = el('li', 'nce-blog-related__item'), link = el('a', 'nce-blog-related__link');
        link.href = a.url; link.setAttribute('data-nce-track', 'related');
        var img = typeof a.image === 'string' ? a.image : (a.featured_image && a.featured_image.url) || (a.image && a.image.url) || '';
        if (img && /^(https:)?\/\//.test(img)) {
          var im = el('img', 'nce-blog-related__img');
          im.src = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=480';
          im.alt = ''; im.loading = 'lazy'; im.width = 480; im.height = 270;
          link.appendChild(im);
        }
        var body = el('span', 'nce-blog-related__body');
        body.appendChild(el('span', 'nce-blog-related__title', a.title));
        var ex = clip(textOf(a.summary_html || ''), 120);
        if (ex) body.appendChild(el('span', 'nce-blog-related__text', ex));
        link.appendChild(body);
        li.appendChild(link); ul.appendChild(li);
      });
      box.hidden = false;
    }
    if ('IntersectionObserver' in window) {          /* pas laden als de lezer in de buurt komt */
      var io = new IntersectionObserver(function (en) {
        if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); load(); }
      }, { rootMargin: '600px 0px' });
      io.observe(root);
    } else { load(); }
  }

  /* ---------- structured data: alleen als die ontbreekt ---------- */
  function hasArticleSchema() {
    var found = false;
    document.querySelectorAll('script[type="application/ld+json"]').forEach(function (s) {
      if (found || s.hasAttribute('data-nce-added')) return;
      var d; try { d = JSON.parse(s.textContent); } catch (e) { return; }
      (function walk(x) {
        if (found || !x || typeof x !== 'object') return;
        if (Array.isArray(x)) { x.forEach(walk); return; }
        var t = [].concat(x['@type'] || []);
        if (t.some(function (v) { return /^(Article|BlogPosting|NewsArticle)$/.test(v); })) { found = true; return; }
        if (x['@graph']) walk(x['@graph']);
      })(d);
    });
    if (!found) found = !!document.querySelector('[itemtype*="schema.org/BlogPosting"], [itemtype*="schema.org/Article"]');
    return found;
  }
  function schema(root) {
    var src = root.querySelector('script[data-nce-schema]');
    if (!src || root.getAttribute('data-schema') !== 'auto') return;
    function go() {
      if (hasArticleSchema()) return;
      var data; try { data = JSON.parse(src.textContent); } catch (e) { return; }
      var s = document.createElement('script');
      s.type = 'application/ld+json'; s.setAttribute('data-nce-added', '');
      s.textContent = JSON.stringify(data);
      document.head.appendChild(s);
    }
    if (document.readyState === 'complete') setTimeout(go, 1500);
    else window.addEventListener('load', function () { setTimeout(go, 1500); });
  }

  /* ---------- meten (alleen als GTM al aanwezig is) ---------- */
  var EVENTS = { choiceguide: 'blog_choiceguide_click', product: 'blog_product_click', related: 'blog_related_article_click' };
  function track(root, name, extra) {
    if (!root || root.getAttribute('data-tracking') !== 'true' || !Array.isArray(window.dataLayer)) return;
    var ev = { event: name, blog_article_id: root.getAttribute('data-article-id'), blog_topic: root.getAttribute('data-topic') };
    for (var k in extra) ev[k] = extra[k];
    window.dataLayer.push(ev);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-nce-track]');
    if (!a) return;
    var root = active;
    var kind = a.getAttribute('data-nce-track');
    if (!EVENTS[kind]) return;
    var extra = { blog_module: kind };
    if (a.getAttribute('data-nce-pos')) extra.blog_position = a.getAttribute('data-nce-pos');
    if (a.getAttribute('data-nce-product')) extra.product_id = a.getAttribute('data-nce-product');
    track(root, EVENTS[kind], extra);
  });

  /* ---------- start ---------- */
  var active = null;
  function init() {
    var roots = document.querySelectorAll('.nce-blog[data-nce-root]');
    if (!roots.length) return;
    if (active && active.isConnected) return;
    active = roots[0];
    for (var i = 1; i < roots.length; i++) roots[i].hidden = true;  /* sectie per ongeluk dubbel toegevoegd */
    var content = findContent(active);
    if (content) {
      document.querySelectorAll('.nce-blog-toc, .nce-blog-cta--compact').forEach(function (n) { if (!active.contains(n)) n.remove(); });
      document.querySelectorAll('.nce-blog-inline').forEach(function (n) { if (!active.contains(n) && !n.classList.contains('nce-blog-cta--compact')) n.remove(); });
      buildToc(active, content);
      placeAll(active, content);
    }
    related(active);
    schema(active);
  }

  window.NCEBlog = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { active = null; init(); });
})();
